import React from 'react'

/**
 * Shared form control classes for Custom Report Builder
 * Ensures identical 40px (h-10) heights, typography, and clean 8px borders
 * across all inputs, textareas, and AppDropdown triggers.
 */
export const INPUT_CLASS =
  'block h-10 w-full rounded-[8px] border border-surface-container-high bg-surface px-3 text-sm text-on-surface placeholder:text-on-surface-variant/50 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-colors disabled:opacity-50'

export const INPUT_SM_CLASS =
  'block h-9 w-full rounded-[8px] border border-surface-container-high bg-surface px-3 text-sm text-on-surface placeholder:text-on-surface-variant/50 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-colors disabled:opacity-50'

export const DROPDOWN_TRIGGER_CLASS =
  '!h-10 !py-0 !rounded-[8px] !border-surface-container-high !bg-surface !px-3 text-sm text-on-surface !shadow-none hover:border-primary/50 focus-visible:ring-1 focus-visible:ring-primary'

export const DROPDOWN_TRIGGER_SM_CLASS =
  '!h-9 !py-0 !rounded-[8px] !border-surface-container-high !bg-surface !px-3 text-sm text-on-surface !shadow-none hover:border-primary/50 focus-visible:ring-1 focus-visible:ring-primary'

export const LABEL_CLASS =
  'text-[11px] font-bold uppercase tracking-wider text-on-surface-variant block mb-1.5'

export const SECTION_TITLE_CLASS =
  'text-xs font-bold uppercase tracking-wider text-on-surface'

/**
 * StepHeader — Shared header component across wizard steps
 */
export function StepHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-b border-surface-container pb-2 mb-3">
      <div>
        <h3 className="text-sm font-bold text-on-surface">{title}</h3>
        {subtitle && <p className="text-[11px] text-on-surface-variant">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  )
}

/**
 * StepCard — Standard background card container with crisp 10px rounded border
 */
export function StepCard({ title, subtitle, actions, children, className = '' }) {
  return (
    <div className={`bg-surface-container-low p-4 rounded-[10px] border border-surface-container space-y-3 ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between">
          <div>
            {title && <h4 className="text-xs font-bold text-on-surface">{title}</h4>}
            {subtitle && <p className="text-[10px] text-on-surface-variant">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-1.5">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
